<template>
    <ExtendedLayout
        :user="user"
        currentTab="permissions"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2 mb-4">
                <InertiaLink :href="$route('admin::users.permissions.index', { user: user.id })">
                    <ChevronLeftIcon class="w-4 h-4 text-gray-500" />
                </InertiaLink>
                {{ __('admin::general.create_model', {'model': __('admin::permissions.permission').toLowerCase() }) }}
            </Heading>

            <form @submit.prevent="submit">

                <FormGroup :label="__('admin::labels.service')" :error="errors.service">
                    <Select name="service" :options="serviceOptions" :has-error="exists(errors.service)" v-model="form.service" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.role')" :error="errors.role">
                    <Select name="role" :options="serviceRoleOptions" :has-error="exists(errors.role)" v-model="form.role" />
                </FormGroup>

                <Button :loading="form.processing">
                    {{ __('admin::general.create_model', {'model': __('admin::permissions.permission').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';
import {ChevronLeftIcon} from "@heroicons/vue/outline";

export default {
    components: {
        ChevronLeftIcon,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        user: Object,
        serviceOptions: Object,
        serviceRoleOptions: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                service: Object.keys(this.serviceOptions)[0],
                role: Object.keys(this.serviceRoleOptions)[0],
            })
        }
    },
    methods: {
        submit() {
            this.form
                .post(this.$route('admin::users.permissions.store', { user: this.user.id }));
        },
    }
}
</script>
